export default "__VITE_ASSET__6d762edd__"